<script lang="ts">
    import { _ } from 'svelte-i18n';

    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import IconDropdown from '../../../shared/Icons/IconDropdown.svelte';
    import IconDropup from '../../../shared/Icons/IconDropup.svelte';
    import Checkbox from '../../../shared/Checkbox/Checkbox.svelte';
    import { routes } from '../../../../stores/store';
    import { filter } from '../../../../stores/filter';
    import SearchInput from '../../../shared/SearchInput.svelte';
    import { canWrite } from '../../../shared/Permissions/writeAccess';

    import './JobOne.css';
    import JobOneHeaderSortableColumn from '../../../shared/HeaderSortableColumn.svelte';

    export let jobFilter: ApiFilterBuilder;
    export let onFilterChange: () => void;
    export let simpleView: boolean = false;
</script>

<div class="connection-element connection-element-header" class:simple-view={simpleView}>
    <div class="checkbox">
        <!-- bez tego konto read-only przełączyłoby selectMode na 'filtered' i odsłoniło pasek akcji -->
        <Checkbox
            disabled={!$canWrite}
            label=""
            checked={$routes.selectMode === 'filtered'}
            onChange={v => {
                if ($routes.selectMode === 'selected') {
                    $routes.selectMode = 'filtered';
                    $routes.selectedOrUnselected = [];
                } else {
                    $routes.selectMode = 'selected';
                    $routes.selectedOrUnselected = [];
                }
            }}
        />
    </div>
    <JobOneHeaderSortableColumn
        label="address-from"
        fieldName="location_from.address_attributes.city"
        className="address-from"
        {jobFilter}
        {onFilterChange}
    />
    <JobOneHeaderSortableColumn
        label="name-from"
        fieldName="location_from.full_name"
        className="name-from"
        {jobFilter}
        {onFilterChange}
    />
    <div class="icons"></div>
    <JobOneHeaderSortableColumn
        label="name-to"
        fieldName="location_to.full_name"
        className="name-to"
        {jobFilter}
        {onFilterChange}
    />
    <JobOneHeaderSortableColumn
        label="address-to"
        fieldName="location_to.address_attributes.city"
        className="address-to"
        {jobFilter}
        {onFilterChange}
    />
    <div class="route-category"></div>
    <JobOneHeaderSortableColumn
        label="route-length"
        fieldName="calculation_result.route_length::int"
        className="route-length"
        {jobFilter}
        {onFilterChange}
    />
    <JobOneHeaderSortableColumn
        label="route-time"
        fieldName="calculation_result.total_time::int"
        className="route-time"
        {jobFilter}
        {onFilterChange}
    />
    <JobOneHeaderSortableColumn
        label="route-cost"
        fieldName="calculation_result.etoll_price::int"
        className="route-cost"
        {jobFilter}
        {onFilterChange}
    />
    <!--    &lt;!&ndash; svelte-ignore a11y-click-events-have-key-events &ndash;&gt;-->
    <!--    &lt;!&ndash; svelte-ignore a11y-no-static-element-interactions &ndash;&gt;-->
    <!--    <div-->
    <!--        class="address-from column-sortable"-->
    <!--        class:sortByHeader={jobFilter.getSortBy()?.field === 'address_attributes.pcode'}-->
    <!--        on:click={() => {-->
    <!--            jobFilter.toggleSortBy(['address_attributes.pcode']);-->
    <!--            onFilterChange();-->
    <!--        }}-->
    <!--    >-->
    <!--        <div>{$_('pcode')}</div>-->
    <!--        {#if jobFilter.getSortBy()?.field === 'address_attributes.pcode'}-->
    <!--            {#if jobFilter.getSortBy()?.direction === 'asc'}-->
    <!--                <IconDropup scale={0.6} />-->
    <!--            {:else}-->
    <!--                <IconDropdown scale={0.6} />-->
    <!--            {/if}-->
    <!--        {/if}-->
    <!--    </div>-->
    <!--    <div class="address quick-search">-->
    <!--        <SearchInput-->
    <!--            placeholder={$_('City, street')}-->
    <!--            query={$filter.connections.quickSearch}-->
    <!--            onChange={q => {-->
    <!--                $filter.connections.quickSearch = q;-->
    <!--            }}-->
    <!--            onKeyup={q => {-->
    <!--                $filter.connections.quickSearch = q;-->
    <!--            }}-->
    <!--            debounceTime={200}-->
    <!--        />-->
    <!--    </div>-->
    <!--        <div class="address column-sortable"-->
    <!--             class:sortByHeader={jobFilter.getSortBy()?.field==='address_attributes.city,address_attributes.street'}-->
    <!--             on:click={()=>{-->
    <!--                 jobFilter.toggleSortBy(['address_attributes.city','address_attributes.street']);-->
    <!--                 onFilterChange();-->
    <!--             }}>-->
    <!--            <div>{$_('Address')}</div>-->
    <!--            {#if jobFilter.getSortBy()?.field==='address_attributes.city,address_attributes.street'}-->
    <!--                {#if jobFilter.getSortBy()?.direction==='asc,asc'}-->
    <!--                    <IconDropup scale={0.6} />-->
    <!--                {:else}-->
    <!--                    <IconDropdown scale={0.6} />-->
    <!--                {/if}-->
    <!--            {/if}-->
    <!--        </div>-->

    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <!--    <div-->
    <!--        class="pcode column-sortable"-->
    <!--        class:sortByHeader={jobFilter.getSortBy()?.field === 'address_attributes.pcode'}-->
    <!--        on:click={() => {-->
    <!--            jobFilter.toggleSortBy(['address_attributes.pcode']);-->
    <!--            onFilterChange();-->
    <!--        }}-->
    <!--    >-->
    <!--        <div>{$_('pcode')}</div>-->
    <!--        {#if jobFilter.getSortBy()?.field === 'address_attributes.pcode'}-->
    <!--            {#if jobFilter.getSortBy()?.direction === 'asc'}-->
    <!--                <IconDropup scale={0.6} />-->
    <!--            {:else}-->
    <!--                <IconDropdown scale={0.6} />-->
    <!--            {/if}-->
    <!--        {/if}-->
    <!--    </div>-->
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <!--    <div-->
    <!--        class="ext_id column-sortable"-->
    <!--        class:sortByHeader={jobFilter.getSortBy()?.field === 'ext_id'}-->
    <!--        on:click={() => {-->
    <!--            jobFilter.toggleSortBy(['ext_id']);-->
    <!--            onFilterChange();-->
    <!--        }}-->
    <!--    >-->
    <!--        <div>{$_('ext_id')}</div>-->
    <!--        {#if jobFilter.getSortBy()?.field === 'ext_id'}-->
    <!--            {#if jobFilter.getSortBy()?.direction === 'asc'}-->
    <!--                <IconDropup scale={0.6} />-->
    <!--            {:else}-->
    <!--                <IconDropdown scale={0.6} />-->
    <!--            {/if}-->
    <!--        {/if}-->
    <!--    </div>-->
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <!--    <div-->
    <!--        class="full_name column-sortable"-->
    <!--        class:sortByHeader={jobFilter.getSortBy()?.field === 'full_name'}-->
    <!--        on:click={() => {-->
    <!--            jobFilter.toggleSortBy(['full_name']);-->
    <!--            onFilterChange();-->
    <!--        }}-->
    <!--    >-->
    <!--        <div>{$_('full_name')}</div>-->
    <!--        {#if jobFilter.getSortBy()?.field === 'full_name'}-->
    <!--            {#if jobFilter.getSortBy()?.direction === 'asc'}-->
    <!--                <IconDropup scale={0.6} />-->
    <!--            {:else}-->
    <!--                <IconDropdown scale={0.6} />-->
    <!--            {/if}-->
    <!--        {/if}-->
    <!--    </div>-->
    <!--    &lt;!&ndash; svelte-ignore a11y-click-events-have-key-events &ndash;&gt;-->
    <!--    &lt;!&ndash; svelte-ignore a11y-no-static-element-interactions &ndash;&gt;-->
    <!--    <div-->
    <!--        class="location_type column-sortable"-->
    <!--        class:sortByHeader={jobFilter.getSortBy()?.field === 'location_type'}-->
    <!--        on:click={() => {-->
    <!--            jobFilter.toggleSortBy(['location_type']);-->
    <!--            onFilterChange();-->
    <!--        }}-->
    <!--    >-->
    <!--        <div>{$_('location_type')}</div>-->
    <!--        {#if jobFilter.getSortBy()?.field === 'location_type'}-->
    <!--            {#if jobFilter.getSortBy()?.direction === 'asc'}-->
    <!--                <IconDropup scale={0.6} />-->
    <!--            {:else}-->
    <!--                <IconDropdown scale={0.6} />-->
    <!--            {/if}-->
    <!--        {/if}-->
    <!--    </div>-->
    <!--    <div class="other"></div>-->
</div>
